module.exports = __webpack_public_path__ + "img/bottle_stat.725f010c.png";